var render = function render(_c,_vm){return _c('div',{staticClass:"d-flex justify-content-center align-items-center w-100"},[_c('div',{staticClass:"text-center"},[_c('b-icon',{staticClass:"p-1 rounded-circle bg-success-100",attrs:{"icon":"check","variant":"success","font-scale":_vm.props.iconFontScale}}),_c('h4',{staticClass:"text-muted mt-3 mb-0"},[_vm._v(_vm._s(_vm.props.message))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }